"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("../../elements");
const ModalFooter = ({ children, rule, }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [rule && (0, jsx_runtime_1.jsx)(elements_1.Hr, {}, void 0), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "modal__footer" }, { children: children }), void 0)] }, void 0));
exports.ModalFooter = ModalFooter;
//# sourceMappingURL=ModalFooter.js.map